import { IDrop } from '../../types/reducerTypes'

export enum DropStatus {
  TBA = 'TBA',
  ComingSoon = 'Coming soon',
  Closed = 'Closed',
  Live = 'Live',
}

export function getDropDateStatus(drop: IDrop) {
  const { start, end } = drop?.dropSettings ?? {}
  const now = new Date()

  const isTba = !start
  if (isTba) return DropStatus.TBA

  const isComingSoon = start && new Date(start) > now
  const isClosed = end && new Date(end) < now
  if (isComingSoon) return DropStatus.ComingSoon
  if (isClosed) return DropStatus.Closed
  return DropStatus.Live
}

export function getIsDropChapterDisabled(drop: IDrop, index?: number) {
  const status = getDropDateStatus(drop)
  return (
    // go horse to allow testing first chapter
    index !== 0 &&
    (status === DropStatus.ComingSoon || status === DropStatus.TBA)
  )
}
